import { keyframes } from "styled-components";

export const textAnimation = keyframes`
  0% {
    opacity: 0;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const imageSectionAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate(-140%);
  }
  10% {
    opacity: 0;
    transform: translate(-140%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
`;

export const screenSectionAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate(140%);
  }
  50% {
    opacity: 0;
    transform: translate(140%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
`;

export const OddImageSectionAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate(140%);
  }
  10% {
    opacity: 0;
    transform: translate(140%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
`;

export const OddScreenSectionAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translate(-140%);
  }
  50% {
    opacity: 0;
    transform: translate(-140%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
`;
